import { createReducer, on } from "@ngrx/store";
import { UserActions } from '../actions/index';
import { UserState } from "../user-data.state";

export const initialState: UserState = {
  b2bCustomers: null,
  success: null,
  loading: null,
  error: null,
};

export const UsersReducer = createReducer(
  initialState,
  on(UserActions.loadUsersTableData, (state) => {
    return ({
      ...state,
      loading: true,
      success: null,
      error: null,
    })
  }),

  on(UserActions.loadUsersTableDataSuccess, (state, { b2bCustomers }) => {
    return ({
      ...state, b2bCustomers,
      loading: null,
      success: true,
      error: null,
    })
  }),
  on(UserActions.loadUsersTableDataFail, (state, { payload }) => {
    return ({
      ...state,
      loading: null,
      success: null,
      error: payload,
    })
  }),

);